import React, { useEffect, useState } from "react";
import { formatDistanceToNow } from "date-fns";
import { X } from "lucide-react";
import axios from "axios";

const Notifications = ({ open, onClose, token, onMarkedAsRead }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const accessToken = localStorage.getItem("access");

  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          "https://api.upswap.app/api/notifications/",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        setNotifications(response.data || []);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };

    if (open) {
      fetchNotifications();
    }
    // eslint-disable-next-line
  }, [open]);

  const handleNotificationClick = async (notificationId) => {
    try {
      await axios.patch(
        `https://api.upswap.app/api/notifications/mark-as-read/${notificationId}/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (onMarkedAsRead) {
        onMarkedAsRead(notificationId);
      }

      // Refresh notification list
      setNotifications((prev) =>
        prev.map((item) =>
          item.id === notificationId ? { ...item, is_read: true } : item
        )
      );
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  return (
    <div
      className={`absolute lg:top-[65px] top-0 right-0 h-[calc(100vh-74px)]  sm:w-96 w-[calc(100vw-6px)]  bg-white shadow-lg z-50 rounded-l-md transform transition-transform duration-300  ${
        open ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="p-4 relative h-full flex flex-col w-full">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-orange-500"
        >
          <X size={20} />
        </button>

        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          Notifications
        </h2>

        {/* Loader */}
        {loading ? (
          <div className="flex justify-center items-center flex-1">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
          </div>
        ) : notifications.length === 0 ? (
          <p className="text-gray-500">No notifications found.</p>
        ) : (
          <ul className="space-y-2 overflow-y-auto pr-2 flex-1">
            {notifications.map((item) => (
              <li
                key={item.id}
                onClick={() => handleNotificationClick(item.id)}
                className={`cursor-pointer border rounded-md p-3 shadow-sm ${
                  item.is_read ? "bg-white" : "bg-blue-50"
                }`}
              >
                <div className="flex justify-between items-start gap-2">
                  {/* Left content */}
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-blue-700">
                      {item.title}
                    </p>
                    <p className="text-sm text-gray-800 mt-1 break-words whitespace-normal">
                      {item.body}
                    </p>
                    {item.notification_type && (
                      <span className="text-xs text-gray-500 italic">
                        Type: {item.notification_type}
                      </span>
                    )}
                  </div>

                  {/* Right bottom-aligned timestamp */}
                  <div className="flex flex-col justify-end">
                    <span className="text-xs text-gray-500 whitespace-nowrap">
                      {formatDistanceToNow(new Date(item.created_at), {
                        addSuffix: true,
                      })}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Notifications;
